function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhotoshop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "480px",
    height: "480px",
    viewBox: "0 0 480 468",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial0",
    gradientUnits: "userSpaceOnUse",
    cx: -183.69,
    cy: 328.972,
    fx: -183.69,
    fy: 328.972,
    r: 0.76,
    gradientTransform: "matrix(440.000954,0,0,425.913591,80988.690009,-139997.70667)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(20.392157%,21.176471%,30.588235%)",
      stopOpacity: 0.980392
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(4.705882%,3.137255%,14.117647%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#radial0)"
    },
    d: "M 20 20.042969 L 460 20.042969 L 460 447.957031 L 20 447.957031 Z M 20 20.042969 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(19.215686%,77.254902%,94.117647%)",
      fillOpacity: 1
    },
    d: "M 20 20.042969 L 460 20.042969 L 460 447.957031 L 20 447.957031 Z M 0 467.953125 L 480 467.953125 L 480 0.046875 L 0 0.046875 Z M 323.601562 192.007812 C 307.800781 192.007812 302.402344 200.007812 302.402344 206.605469 C 302.402344 213.804688 306 218.800781 327.199219 229.800781 C 358.601562 244.996094 368.402344 259.59375 368.402344 280.992188 C 368.402344 312.984375 344 330.179688 311 330.179688 C 293.601562 330.179688 278.601562 326.582031 270 321.582031 C 268.601562 320.984375 268.402344 319.984375 268.402344 318.382812 L 268.402344 288.988281 C 268.402344 286.988281 269.402344 286.390625 270.800781 287.390625 C 283.402344 295.589844 297.800781 299.1875 311 299.1875 C 326.800781 299.1875 333.402344 292.589844 333.402344 283.589844 C 333.402344 276.390625 328.800781 269.992188 308.601562 259.59375 C 280.199219 245.996094 268.402344 232.199219 268.402344 209.207031 C 268.402344 183.410156 288.601562 162.015625 323.601562 162.015625 C 340.800781 162.015625 352.800781 164.613281 359.402344 167.613281 C 361 168.613281 361.402344 170.210938 361.402344 171.613281 L 361.402344 199.007812 C 361.402344 200.605469 360.402344 201.605469 358.398438 201.003906 C 349.601562 195.40625 336.601562 192.007812 323.601562 192.007812 Z M 151.601562 215.804688 C 156.199219 216.203125 159.800781 216.203125 167.800781 216.203125 C 191.203125 216.203125 213.199219 208.003906 213.199219 176.210938 C 213.199219 150.816406 197.402344 138.019531 170.800781 138.019531 C 162.800781 138.019531 155.199219 138.417969 151.601562 138.621094 Z M 116 109.625 C 116 108.226562 118.800781 107.226562 120.398438 107.226562 C 133.199219 106.625 152.199219 106.226562 172 106.226562 C 227.402344 106.226562 249 136.621094 249 175.410156 C 249 226.199219 212.199219 247.996094 167 247.996094 C 159.402344 247.996094 156.800781 247.597656 151.398438 247.597656 L 151.398438 324.382812 C 151.398438 325.980469 150.800781 326.78125 149 326.78125 L 118.402344 326.78125 C 116.800781 326.78125 116 326.179688 116 324.382812 Z M 116 109.625 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoshop);
export default __webpack_public_path__ + "static/media/photoshop.d1aac1cd15b4686201ff5206b843e046.svg";
export { ForwardRef as ReactComponent };